import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Modal, Alert } from "react-bootstrap";
import DetailsTable from "../../components/table/index";
import Footer from "../../components/footer/index";
import SelectDropdown from "../../components/dropdown/index";
import SpinnerComp from "../../components/spinner/index";
import CustomButton from "../../components/button/index";
import axios from "axios";
import SearchBar from "../../components/searchbar/index";
import { MdAssignment } from "react-icons/md";
import { RiDeleteBackFill } from "react-icons/ri";
import { IoPrintSharp } from "react-icons/io5";
import { MdOutlineDownloadDone } from "react-icons/md";
import { toast, ToastContainer } from 'react-toastify';

const ProcessShipments = ({ user }) => {
  const [pendingShipments, setPendingShipments] = useState([]);
  const [selectedShipments, setSelectedShipments] = useState([]);
  const [riders, setRiders] = useState([]);
  const [selectedRider, setSelectedRider] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const pendingShipmentsRef = React.useRef([]);

  const fetchShipments = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/shipment/all`,
        {
          params: {
            search: searchTerm,
            isToAssign: true
          },
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      if (response.status === 200) {
        setPendingShipments(response.data.shipments);
      }

      setLoading(false);
    } catch (err) {
      console.error("Error fetching shipments:", err);
      toast.error("Failed to fetch shipments. Please try again.");
      setLoading(false);
    }
  };

  const fetchRiders = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/users/all-user`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          params: { status: "active", role: "rider" },
        }
      );
      setRiders(
        response.data.sellers.map((rider) => ({
          value: rider._id,
          label: rider.name,
        }))
      );
    } catch (err) {
      console.error("Error fetching riders:", err);
    }
  };

  const handleAssignShipment = (shipment) => {
    setPendingShipments((prev) =>
      prev.filter((item) => item.shipmentId !== shipment.shipmentId)
    );
    setSelectedShipments((prev) => [...prev, shipment]);
    console.log(selectedShipments);
    
  };

  const handleUnassignShipment = (shipment) => {
    setSelectedShipments((prev) =>
      prev.filter((item) => item.shipmentId !== shipment.shipmentId)
    );
    setPendingShipments((prev) => [...prev, shipment]);
  };

  const handleBarcodeScan = (barcode) => {

    const trimmedBarcode = barcode.trim();
    console.log(trimmedBarcode);
    console.log(pendingShipmentsRef.current);

    const shipment =  pendingShipmentsRef.current.find(
      (item) => item.shipmentId == trimmedBarcode
    );
    console.log(shipment);
    //console.log(trimmedBarcode);
    
    if (shipment) {
      handleAssignShipment(shipment);
    } else {
      toast.error("Shipment not found for the scanned barcode.");
    }
  };
  const handlePrint = () => {
    const shipmentIds = selectedShipments.map(shipment => shipment.shipmentId).join("<br>");
    
    const printContent = `
      <html>
        <head>
          <title>Assigned Shipments</title>
        </head>
        <body>
          <h2>Rider: ${selectedRider?.label || "N/A"}</h2>
          <h3>Shipment IDs:</h3>
          <div>${shipmentIds}</div>
        </body>
      </html>
    `;
  
    const newWindow = window.open("", "_blank");
    newWindow.document.write(printContent);
    newWindow.print();
    newWindow.close();
  };
  const handleSubmit = async () => {
    if (!selectedRider || selectedShipments.length === 0) {
      toast.error("Please select a rider and at least one shipment to proceed.");
      return;
    }

    try {
      const shipmentIds = selectedShipments.map((shipment) => shipment.shipmentId);
      console.log(shipmentIds);
      
      const response= await axios.post(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/shipment/assign`,
        {
          riderId: selectedRider.value,
          shipmentId: shipmentIds,
          status: "in transit",
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      console.log(response);
      toast.success("Shipment has been assigned Successfully")

      setShowModal(false);
      
      setSelectedShipments([]);
      fetchShipments(); // Refresh pending shipments
    } catch (err) {
      console.error("Error updating shipments:", err);
      toast.error("Failed to assign shipments. Please try again.");
    }
  };
  useEffect(() => {
    pendingShipmentsRef.current = pendingShipments; // Sync the ref with the latest state
  }, [pendingShipments]);
  
  useEffect(() => {
    fetchShipments(); // Populate pendingShipments
    fetchRiders();    // Populate riders if needed
  
    let buffer = ""; // Temporary buffer to store barcode characters
    let sequenceStarted = false; // Flag to track if the starting sequence is met
    let sequenceBuffer = ""; // Separate buffer for the sequence

    const handleKeyDown = (event) => {
  
      if (!sequenceStarted) {
        // Check for the specific starting sequence: Shift → F → S → D
        if (event.key === "Shift" && sequenceBuffer === "") {
          sequenceBuffer = "Shift";
        } else if (sequenceBuffer === "Shift" && event.key === "F") {
          sequenceBuffer += "F";
        } else if (sequenceBuffer === "ShiftF" && event.key === "D") {
          sequenceBuffer += "D";
        } else if (sequenceBuffer === "ShiftFD" && event.key === "S") {
          sequenceBuffer += "S";
        } else if (sequenceBuffer === "ShiftFDS" && event.key === "-") {
          sequenceBuffer = ""; // Reset the sequence buffer
          sequenceStarted = true; // Sequence matched, start listening for barcode
          buffer = "FDS-"; // Pre-fill the buffer with the required prefix
          //console.log("Sequence matched. Listening for barcode...");
        } else {
        }
        //console.log("Sequence buffer:", sequenceBuffer);
        return;
      }
  
        // If the sequence has started, process the barcode
    if (event.key === "Enter") {
      if (buffer.trim() && buffer.startsWith("FDS-")) {
        console.log("Barcode captured:", buffer); // Log the captured barcode
        const proceed = buffer
        buffer = ""; // Clear the buffer after processing
        handleBarcodeScan(proceed.trim()); // Process the barcode
        sequenceStarted = false; // Reset the sequence flag
      } else {
        console.warn("Invalid barcode. Resetting...");
        buffer = ""; // Reset the buffer if it doesn't meet the criteria
        sequenceStarted = false; // Reset the sequence flag
      }
    } else {
      buffer += event.key; // Append the key to the buffer
    }
    };
  
    // Attach keydown listener
    window.addEventListener("keydown", handleKeyDown);
  
    // Cleanup listener on unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Empty dependency array: This runs only once on mount
  
  

  if (loading) return <SpinnerComp />;

  const filteredShipments = pendingShipments.filter((shipment) =>
    shipment.shipmentId.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container fluid className="p-4 bg-light" style={{minHeight:"92vh"}}>
            <ToastContainer/>
      <h2 style={{ color: '#005A9C' }}>Process Shipments</h2>
    <br/>

      <Row>
        {/* Left Table */}
        <Col md={6}>
          <Card className="shadow-sm" style={{ height:"72vh" }}>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5>Pending Shipments</h5>
                <div>
                <SearchBar
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search Shipments..."
                />
                </div>
              </div>

              <div style={{ height:"58vh", overflowY: "auto" }}>
                {filteredShipments.length === 0 ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                  <Alert className="text-center" style={{ width: '50%', backgroundColor:"#005A9C", color:"white"}}>
                    No shipment found
                  </Alert>
                  </div>
                ) : (
                  <DetailsTable
                    isTransparent={true}
                    data={filteredShipments}
                    columns={[
                      { header: "Barcode", render: (item) => item.shipmentId },
                      { header: "Status", render: (item) => item.status },

                      {
                        header: "Action",
                        render: (item) => (
                            <div className="d-flex justify-content-center gap-2">
                                <CustomButton
                                    variant="primary"
                                    onClick={() => handleAssignShipment(item)}
                                >
                                    <MdAssignment/><div className="ml-3">Assign</div>
                                </CustomButton>
                          </div>
                          
                        ),
                      },
                    ]}
                  />
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
            
        {/* Right Table */}
        <Col md={6}>
          <Card className="shadow-sm" style={{ height:"72vh" }}>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 className="mt-4">Selected Shipments</h5>
                <SelectDropdown
                  options={riders}
                  value={selectedRider?.value}
                  onChange={(e) => setSelectedRider(e)}
                  placeholder="Select a Rider"
                />
              </div>
              <div id="print-area" className="mt-4" style={{ height:"58vh", overflowY: "auto" }}>
                {selectedShipments.length === 0 ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                  <Alert className="text-center" style={{ width: '50%', backgroundColor:"#005A9C", color:"white"}}>
                    No shipment assigned
                  </Alert>
                  </div>
                ) : (
                  <DetailsTable
                    isTransparent={true}
                    data={selectedShipments}
                    columns={[
                      { header: "Shipment", render: (item) => item.shipmentId },
                      {
                        header: "Action",
                        render: (item) => (
                            <div className="d-flex justify-content-center gap-2">
                                <CustomButton
                                    variant="danger"
                                    onClick={() => handleUnassignShipment(item)}
                                >
                                    <RiDeleteBackFill/> <div className="ml-3">Unassign</div>
                                </CustomButton>
                            </div>
                        ),
                      },
                    ]}
                  />
                )}
              </div>
            </Card.Body>
          </Card>
          <span className="ml-1 mt-3 text-center block">Total Assigned Shipments: {selectedShipments.length}</span>

        </Col>
      </Row>


      <div className="d-flex justify-content-end mt-4">
        <CustomButton
          variant="secondary"
          onClick={handlePrint}
          isDisabled={selectedShipments.length === 0}
          className="me-3"
        >
         <IoPrintSharp/> <div className="ml-3">Print</div>
        </CustomButton>
        <CustomButton
          variant="primary"
          onClick={() => setShowModal(true)}
          isDisabled={!selectedRider || selectedShipments.length === 0}
        >
          <MdOutlineDownloadDone/><div className="ml-3">Submit</div>
        </CustomButton>
      </div>
      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Assignment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to assign these shipments to{" "}
          {selectedRider?.label}?
        </Modal.Body>
        <Modal.Footer>
          <CustomButton variant="danger" onClick={() => setShowModal(false)}>
            Cancel
          </CustomButton>
          <CustomButton variant="primary" onClick={handleSubmit}>
            Confirm
          </CustomButton>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ProcessShipments;
